import React, { useState, useEffect } from "react";
import Timer from "../components/Timer";
import LoadingTimer from "../components/LoadingTimer";
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import AssetGrid from "../components/AssetGrid";
import TopFields from "../components/TopFields";
import { API } from "aws-amplify";
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  }
}));

const menuList = ['MC', 'Period', 'Toilet', 'Meal', 'Off Day', 'Call', 'Make Up'];
const initRooms = [{"roomId":"room1","endTime":"2023-09-23T08:22:24.216Z","extend":false,"extendPrice":"120","onlineStatus":false,"price":"0","roomDisabled":false,"roomName":"Room 1","roomNum":1,"startTime":"2023-09-23T02:37:53.627Z","type":"S"},{"roomId":"room2","endTime":"2023-09-16T09:19:18.785Z","extend":false,"extendPrice":"60","onlineStatus":false,"price":"0","roomDisabled":false,"roomName":"Room 2","roomNum":2,"startTime":"2023-09-16T08:54:18.785Z","type":"S"},{"roomId":"room3","endTime":"2023-09-17T09:33:44.403Z","extend":false,"extendPrice":"0","onlineStatus":false,"price":"60","roomDisabled":false,"roomName":"Room 3","roomNum":3,"startTime":"2023-09-17T09:08:44.403Z","type":"M"},{"roomId":"room5","endTime":"2023-09-16T09:19:18.785Z","extend":false,"extendPrice":"0","onlineStatus":false,"price":"60","roomDisabled":false,"roomName":"Room 5","roomNum":5,"startTime":"2023-09-16T08:54:18.785Z","type":"M"},{"roomId":"room6","endTime":"2023-09-23T08:25:30.612Z","extend":false,"extendPrice":"60","onlineStatus":false,"price":"0","roomDisabled":false,"roomName":"Room 6","roomNum":6,"startTime":"2023-09-22T02:12:46.164Z","type":"M"},{"roomId":"room7","endTime":"2023-09-23T08:26:48.202Z","extend":false,"extendPrice":"90","onlineStatus":false,"price":"0","roomDisabled":false,"roomName":"Room 7","roomNum":7,"startTime":"2023-09-16T08:54:18.785Z","type":"VIP"},{"roomId":"room8","endTime":"2023-09-16T09:19:18.785Z","extend":false,"extendPrice":"0","onlineStatus":false,"price":"60","roomDisabled":false,"roomName":"Room 8","roomNum":8,"startTime":"2023-09-16T08:54:18.785Z","type":"VIP"},{"roomId":"room9","endTime":"2023-09-16T09:19:18.785Z","extend":false,"extendPrice":"0","onlineStatus":false,"price":"60","roomDisabled":false,"roomName":"Room 9","roomNum":9,"startTime":"2023-09-16T08:54:18.785Z","type":"VIP"},{"roomId":"room10","endTime":"2023-09-24T08:45:26.683Z","extend":false,"extendPrice":"0","onlineStatus":false,"price":"0","roomDisabled":false,"roomName":"Room 10","roomNum":10,"startTime":"2023-09-24T08:43:08.582Z","type":"S"},{"roomId":"room11","endTime":"2023-09-23T08:46:29.899Z","extend":false,"extendPrice":"90","onlineStatus":false,"price":"0","roomDisabled":false,"roomName":"Room 11","roomNum":11,"startTime":"2023-09-23T08:44:20.129Z","type":"S"},{"roomId":"room12","endTime":"2023-09-16T09:19:18.785Z","extend":false,"extendPrice":"0","onlineStatus":false,"price":"60","roomDisabled":false,"roomName":"Room 12","roomNum":12,"startTime":"2023-09-16T08:54:18.785Z","type":"M"}]

export default function MainRoom(props) {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  const [packages, setPackages] = useState("");
  const [assetList, updateAssetList] = useState("");
  const [rooms, setRooms] = useState("");
  const [selectedAsset, setSelectedAsset] = useState("");
  const [price, setPrice] = useState(0);
  const [errorOpen, setErrorOpen] = React.useState(false);

  const handleErrorClick = () => {
    setErrorOpen(true);
  };

  const handleErrorClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setErrorOpen(false);
  };

  useEffect(() => {
    setLoading(true);
    setRooms("");

    function onLoad() {

      API.get("api01a3cfb8", '/rooms').then(response => {
        setLoading(false);
        setRooms(response.data.sort((a, b) => (a.roomNum - b.roomNum)));
      }).catch(error => {
        handleErrorClick();
        console.log(error);
      });

      API.get("api01a3cfb8", '/packages').then(response => {
        setLoading(false);
        setPackages(response.data.sort((a, b) => (a.price - b.price)));
      }).catch(error => {
        handleErrorClick();
        console.log(error);
      });

      API.get("api01a3cfb8", '/assets').then(response => {
        updateAssetList(response.data.sort((a, b) => (a.assetId - b.assetId)));
      }).catch(error => {
        handleErrorClick();
        console.log(error);
      });

    }
    onLoad();
  }, []);


  async function getAssetPrice(assetName) {
    const getAssets = await API.get("api01a3cfb8", "/assets");
    const price = getAssets.data.filter(it => assetName === it.assetName)[0].price;
    return price;
  }

  async function updateTracking(assetId, tracking, price) {
    setLoading(true);
    const currentTime = new Date().toISOString();

    updateAssetList(assetList.map(el => (el.assetId === assetId ? Object.assign({}, el, { tracking: tracking, updatedTime: currentTime }) : el)));
    if (assetId === "" || assetId === null) return new Error("Invalid Girl");

    const options = {
      body: {
        tracking: tracking,
        price: price,
        updatedTime: currentTime
      }
    };
    await API.put("api01a3cfb8", `/assets/${assetId}`, options).then(response => {
      // Add your code here
      setLoading(false);
    }).catch(error => {
      handleErrorClick();
      console.log(error);
    });

  }

  async function updateRoomStatus(roomId, roomDisabled) {

    const options = {
      body: {
        roomDisabled: roomDisabled
      }
    };

    await API.put("api01a3cfb8", `/rooms/updateRoomStatus/${roomId}`, options).then(response => {
      // Add your code here
      setLoading(false);
    }).catch(error => {
      handleErrorClick();
      console.log(error);
    });
  }

  async function endRoomTime(currentTime, roomId) {
    const options = {
      body: {
        endTime: currentTime.toISOString(),
        price: 0
      }
    };
    API.put("api01a3cfb8", `/rooms/updateTime/${roomId}`, options)
      .then(response => {
        window.location.reload(false);
      }).catch(error => {
        handleErrorClick();
        console.log(error);
      });

  }

  async function createTransaction(assetId, assetName, tracking, duration, price, endTime, startTime) {
    if (assetName === "" || assetName === null) return new Error("Invalid Girl");
    if (price === 0 && tracking.includes("Room")) return new Error("Invalid Transaction");

    const options = {
      body: {
        assetName: assetName,
        tracking: tracking,
        duration: duration,
        price: price,
        status: "Valid",
        startTime: startTime,
        endTime: endTime,
        tai: 0
      }
    };

    API.post("api01a3cfb8", '/transactions', options)
      .then(response => {
        // Add your code here
        updateTracking(assetId, tracking, 0)
      }).catch(error => {
        handleErrorClick();
        console.log(error);
      });

  }


  async function getRoomStartTime(roomId) {
    const getRooms = await API.get("api01a3cfb8", `/rooms/${roomId}`);
    return getRooms[0].startTime;
  }

  async function updateTransactionEndTime(assetsInRoom) {
    const currentTime = new Date().toISOString();

    setLoading(true);
    for (var assets in assetsInRoom) {
      var assetName = assetsInRoom[assets].assetName;
      if (assetName === "" || assetName === null) return new Error("Invalid Girl");

      await API.get("api01a3cfb8", `/transactions/${assetName}`)
        .then(response => {
          const startTime = new Date(response[0].startTime).toISOString();
          const price = response[0].price;
          const options = {
            body: {
              endTime: currentTime,
              price: price,
              status: "Valid"
            }
          };

          API.put("api01a3cfb8", `/transactions/updateStatus/${assetName}/${startTime}`, options)
            .then()
            .catch(error => {
              handleErrorClick();
              console.log(error);
            });

        }).catch(error => {
          handleErrorClick();
          console.log(error);
        });
      updateTracking(assetsInRoom[assets].assetId, "Available", 0);
    }

    setLoading(false);
  }

  async function extendRoom(roomId, startTime, endTime, price, extendPrice) {
    const options = {
      body: {
        startTime: startTime.toISOString(),
        endTime: endTime.toISOString(),
        price: price,
        extend: true,
        extendPrice: extendPrice
      }
    };
    API.put("api01a3cfb8", `/rooms/${roomId}`, options)
      .then(response => {
        // Add your code here
        setLoading(false);
        window.location.reload(false);
      })
      .catch(error => {
        handleErrorClick();
        console.log(error);
      });
  }

  async function createTransactionDate(assetsInRoom, price, duration, tracking, status, roomId) {
    const endTime = new Date().toISOString();
    if (duration <= 0) duration = 0;
    const startTime = await getRoomStartTime(roomId);

    setLoading(true);
    for (var assets in assetsInRoom) {
      var assetName = assetsInRoom[assets].assetName;

      if (assetName === "" || assetName === null) return new Error("Invalid Girl");

      if (price === 0 && tracking.includes("Room") && status === "Valid") {
        price = await getAssetPrice(assetName);
      }

      const options = {
        body: {
          assetName: assetsInRoom[assets].assetName,
          tracking: tracking,
          duration: duration,
          price: price,
          tai: Math.floor(price / 60),
          status: status,
          startTime: startTime,
          endTime: endTime
        }
      };

      await API.post("api01a3cfb8", '/transactions', options);
      updateTracking(assetsInRoom[assets].assetId, "Available", 0);
    }

    setLoading(false);
  }



  async function updateRoom(roomId, endTime, startTime, price) {
    if (roomId === "" || roomId === null) return new Error("Invalid Room");
    setLoading(true);

    const options = {
      body: {
        startTime: startTime,
        endTime: endTime,
        price: price,
        extend: false,
        extendPrice: 0
      }
    };
    API.put("api01a3cfb8", `/rooms/${roomId}`, options)
      .then(response => {
        // Add your code here
        setLoading(false);
        window.location.reload(false);
      })
      .catch(error => {
        handleErrorClick();
        console.log(error);
      });

  }

  function RoomsCard(props) {
    return (
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        style={{marginTop:'10px'}}
      >
        {assetList !== "" && props.map((key) =>
          <Grid item sm={3} key={props.indexOf(key)}>
            <Timer
              roomName={key.roomName}
              roomType={key.type}
              endTime={key.endTime}
              roomId={key.roomId}
              startTime={key.startTime}
              extendPrice={key.extendPrice}
              roomDisabled={key.roomDisabled}
              extend={key.extend ? "Extend (+$" + key.extendPrice + ")" : ""}
              getRoomStartTime={getRoomStartTime}
              time={key.time}
              extendRoom={extendRoom}
              setPrice={setPrice}
              createTransactionDate={createTransactionDate}
              price={key.price || price}
              packages={packages}
              endRoomTime={endRoomTime}
              selectedAsset={selectedAsset}
              setSelectedAsset={setSelectedAsset}
              assetList={assetList}
              updateRoomStatus={updateRoomStatus}
              setLoading={setLoading}
              updateRoom={updateRoom}
              updateTracking={updateTracking}
            />
          </Grid>
        )}
      </Grid>
    );
  }

  function LoadingCard(props) {
    return (
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        style={{marginTop:'10px'}}
      >
        {props.map((key) =>
          <Grid item xs={2} sm={2} md={2} key={props.indexOf(key)}>
            <LoadingTimer
              roomName={key.roomName}
              roomType={key.type}
              extend={key.extend}
              endTime={key.endTime}
              roomId={key.roomId}
            />
          </Grid>
        )}
      </Grid>
    );
  }

  return (
    <Container>
      <TopFields
        selectedAsset={selectedAsset}
        menuList={menuList}
        setSelectedAsset={setSelectedAsset}
        updateTracking={updateTracking}
        updateTransactionEndTime={updateTransactionEndTime}
        createTransaction={createTransaction}
        createTransactionDate={createTransactionDate}
        assetList={assetList}
      />
      {rooms !== "" ? RoomsCard(rooms) : LoadingCard(initRooms)}
      <AssetGrid
        assetList={assetList}
        selectedAsset={selectedAsset}
        setSelectedAsset={setSelectedAsset}
        createTransaction={createTransaction}
        createTransactionDate={createTransactionDate}
        updateTransactionEndTime={updateTransactionEndTime}
        updateTracking={updateTracking}
      />
      <Snackbar open={errorOpen} autoHideDuration={6000} onClose={handleErrorClose}>
        <Alert onClose={handleErrorClose} severity="error">
          Oops something went wrong. Please try again.
        </Alert>
      </Snackbar>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Container>
  );
}